import { observable, action, computed, createTransformer, reaction } from "mobx";
import MotivoGeralService from "../../../services/MotivoGeralService";

export default class MotivoGeralStore {

    @observable motivoGeralLista;
    @observable itemSelecionado;
    @observable loading;

    constructor(modalStore) {
        this.modalStore = modalStore;
        this.motivoGeralLista = [];
        this.resetItemSelecionado();
        this.motivoGeralService = new MotivoGeralService();
    }

    resetItemSelecionado() {
        this.itemSelecionado = {
            id: 0,
            escopo: null,
            nome: ""
        };
    }

    carregarLista() {
        this.loading = true;

        const loadingPromises = Promise.all([

            this.motivoGeralService.list().then(response => {
                this.motivoGeralLista = response.data;
            }).catch(error => {
                console.log(error);
            })
        ])
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    }

    setNome(value) {
        this.itemSelecionado.nome = value;
    }

    setEscopo(value) {
        this.itemSelecionado.escopo = value;
    }

    preencherModal(row){
        if(row) {
            this.itemSelecionado = Object.assign({}, row);
        } else {
            this.resetItemSelecionado();
        }
    }

    setLista(value) {
        this.motivoGeralLista = value;
    }

    editar() {
        let tabelaIndex = this.motivoGeralLista.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);
        return this.motivoGeralService.edit(this.itemSelecionado.id, this.itemSelecionado).then(response => {
            this.motivoGeralLista[tabelaIndex] = response.data;
        })
    }

    cadastrar() {
        return this.motivoGeralService.save(this.itemSelecionado).then(response => {
            this.motivoGeralLista.push(response.data);
        });
    }

    remover() {
        let tabelaIndex = this.motivoGeralLista.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);
        let modal = this.modalStore;

        return this.motivoGeralService.delete(this.itemSelecionado.id).then(response => {
            this.motivoGeralLista.splice(tabelaIndex, 1);
            modal.toggleModal()
        }).catch(error => {
            modal.setSubmitMensagemErro(error.response.data.message)
        })
    }


}